import { render, staticRenderFns } from "./personalInformation.vue?vue&type=template&id=49720ecd&"
import script from "./personalInformation.vue?vue&type=script&lang=js&"
export * from "./personalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports